import { render } from "./DonatChartSales.vue?vue&type=template&id=65230ad5&scoped=true"
import script from "./DonatChartSales.vue?vue&type=script&lang=js"
export * from "./DonatChartSales.vue?vue&type=script&lang=js"

import "./DonatChartSales.vue?vue&type=style&index=0&id=65230ad5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65230ad5"]])

export default __exports__